import styled from "styled-components";

export default styled.div`
  background: #e7eaec;
  height: auto;
  width: 1px;
`;
